import {
  Column,
  Entity,
  Index,
  JoinColumn,
  ManyToOne,
  OneToMany,
  PrimaryGeneratedColumn,
} from "typeorm";
import { Services } from "./services.entity";
import { Branches } from "./branches.entity";

@Index("index_area_tree_nodes_on_ancestry", ["ancestry"], {})
@Index("area_tree_nodes_pkey", ["id"], { unique: true })
@Index("index_area_tree_nodes_on_service_id", ["serviceId"], {})
@Entity("area_tree_nodes", { schema: "public", synchronize: false, })
export class AreaTreeNodes {
  @PrimaryGeneratedColumn({ type: "integer", name: "id" })
  id: number;

  @Column("integer", { name: "service_id" })
  serviceId: number;

  @Column("character varying", { name: "ancestry", nullable: true })
  ancestry: string | null;

  @Column("character varying", { name: "name" })
  name: string;

  @Column("timestamp without time zone", { name: "created_at" })
  createdAt: Date;

  @Column("timestamp without time zone", { name: "updated_at" })
  updatedAt: Date;

  @Column("integer", { name: "display_order", default: () => "1" })
  displayOrder: number;

  @Column("character varying", { name: "created_by", nullable: true })
  createdBy: string | null;

  @Column("character varying", { name: "updated_by", nullable: true })
  updatedBy: string | null;

  @ManyToOne(() => Services, (services) => services.areaTreeNodes)
  @JoinColumn([{ name: "service_id", referencedColumnName: "id" }])
  service: Services;

  @OneToMany(() => Branches, (branches) => branches.areaTreeNode)
  branches: Branches[];
}
